import { render } from "./trust-experience-block.vue?vue&type=template&id=459ebdd2"
import script from "./trust-experience-block.vue?vue&type=script&lang=js"
export * from "./trust-experience-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__